import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, startWith, Subscription } from 'rxjs';
import { TracingInfo } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class TracingInfoService {
  private intervalSub: Subscription | null = null;
  private tracingInfoSubject = new BehaviorSubject<TracingInfo | null>(null);
  tracingInfoData$ = this.tracingInfoSubject.asObservable();

  constructor() {
    this.setupTracingInfo();
  }

  getTracingInfo() {
    window.postMessage({ type: 'GetTracingInfo' }, '*');
    window.addEventListener('message', this.listener);
  }

  private listener = (e: any) => {
    if (e.data?.type === 'SetTracingInfo') {
      window.removeEventListener('message', this.listener);
      this.tracingInfoSubject.next(e.data.payload);
    }
  };

  resetTracingInfo(): void {
    this.setInitData(null);
    this.setupTracingInfo();
  }

  setInitData(data: any): void {
    this.tracingInfoSubject.next(data);
  }

  setupTracingInfo() {
    // 1200000 = 20min;
    this.intervalSub?.unsubscribe();
    this.intervalSub = interval(1200000)
      .pipe(startWith(0))
      .subscribe(() => this.getTracingInfo());
  }

}